var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m416 512h-320c-53.023 0-96-42.977-96-96v-320c0-53.023 42.977-96 96-96h320c53.023 0 96 42.977 96 96v320c0 53.023-42.977 96-96 96z",
    fill: "#a1d4e2",
    style: {},
    "data-original": "#e3f8fa",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m160 224v130.67c0 16.207 13.121 29.328 29.328 29.328h133.33c16.223 0 29.344-13.121 29.344-29.328v-130.67zm64 106.67c0 5.8711-4.8008 10.672-10.672 10.672s-10.672-4.8008-10.672-10.672v-64c0-5.8711 4.8008-10.672 10.672-10.672s10.672 4.8008 10.672 10.672zm42.672 0c0 5.8711-4.8008 10.672-10.672 10.672s-10.672-4.8008-10.672-10.672v-64c0-5.8711 4.8008-10.672 10.672-10.672s10.672 4.8008 10.672 10.672zm42.656 0c0 5.8711-4.8008 10.672-10.672 10.672s-10.672-4.8008-10.672-10.672v-64c0.015625-5.8711 4.8164-10.672 10.688-10.672s10.672 4.8008 10.672 10.672v64zm-85.328-181.34h64v10.672h21.328v-10.672c0-11.727-9.6016-21.328-21.328-21.328h-64c-11.727 0-21.328 9.6016-21.328 21.328v10.672h21.328z",
    fill: "#00416d",
    style: {},
    "data-original": "#26c6da",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m373.33 189.33v26.672c0 4.3672-3.6328 8-8 8h-218.66c-4.3672 0-8-3.6328-8-8v-26.672c0-16.207 13.121-29.328 29.328-29.328h176c16.207 0 29.328 13.121 29.328 29.328z",
    fill: "#2a93d4",
    style: {},
    "data-original": "#8ce1eb",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.35ebcace.svg";
export { ForwardRef as ReactComponent };